import { NgModule } from '@angular/core';

import { FlexLayoutModule } from '@angular/flex-layout';

import { CustomBreakPointsProvider } from './custom-breakpoints';
import { VerticalLayoutModule } from './verticals/verticals.module';
import { HorizontalLayoutModule } from './horizontals/horizontals.module';

@NgModule({
  imports: [
    FlexLayoutModule.withConfig({ disableDefaultBps: true }),
    VerticalLayoutModule,
    HorizontalLayoutModule,
  ],
  providers: [CustomBreakPointsProvider],
  exports: [
    VerticalLayoutModule,
    HorizontalLayoutModule
  ],
})
export class LayoutsModule {}
